import { createElement as y } from "react";
import { c as x } from "./client-COlxxEJZ.mjs";
import { T as v } from "./toast-BSWyDdPV.mjs";
const g = "toast-container", t = [];
let c;
const I = ({
  id: o,
  className: e = "",
  duration: n = 3e3,
  clearOtherToast: a,
  zIndex: s = 50,
  onAnimationEnd: i,
  ...f
}) => {
  const r = o || `toast_${Date.now()}`;
  let u;
  const h = C(r, e, s), d = x(h), T = (m) => {
    clearTimeout(u), d.unmount(), h.remove(), m || i == null || i(), N(l);
  }, p = () => {
    d.render(/* @__PURE__ */ y(v, { ...f, active: !0, key: r })), u = window.setTimeout(() => {
      d.render(/* @__PURE__ */ y(v, { ...f, active: !1, key: r, onAnimationEnd: T }));
    }, n);
  }, l = {
    toastKey: r,
    add: p,
    remove: T
  };
  return a && t.forEach(({ remove: m }) => {
    m();
  }), t.push(l), t.length === 1 && (c = t[0], p()), l;
};
function C(o, e, n) {
  const a = document.querySelector("body"), s = document.createElement("div");
  return s.className = `${g} ${o} ${e}`, s.style.position = "relative", s.style.zIndex = n.toString(), a.appendChild(s);
}
function N(o) {
  const e = t.findIndex((n) => n === o);
  if (t.splice(e, 1), t.length > 0) {
    const n = t[0];
    c = n, n.add();
  }
}
function _(o) {
  for (; t.length; ) {
    const e = t.shift();
    e == null || e.remove(o);
  }
  c == null || c.remove(o);
}
export {
  _ as c,
  I as s
};
